import React, { useEffect, useState } from 'react';
import { useHref, useLocation, useNavigate } from 'react-router-dom';
import ParentContainor from '../../components/base/ParentContainor';
import { ROUTE_ENUM } from '../../routes/RoutesConstant';
import { logger } from '../../utils/logger';
import { authService } from '../../services/authService';
import { tambolaGameList } from '../../network/network_callbacks';
import Card from '../../components/base/Card';
import GradientText from '../../components/base/GradientText';
import { TEXT_LABELS } from '../../constants/TextLabelConstants';
import QRCode from '../../components/QRCode';
import Button from '../../components/base/Button';
import { COLORS_CONSTANTS } from '../../constants/Colors';
import { FONTS } from '../../constants/Fonts';
import mqttService from '../../services/mqttService';

const RapHousieWaiting = () => {

    const navigate = useNavigate();
    const location = useLocation();

    const { prevScreen, nextScreen, nextGameToStart } = location.state || {};

    const [timerComplete, setTimerComplete] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [nextGame, setNextGame] = useState(nextGameToStart || null);
    const [gamesList, setGamesList] = useState(null);
    const [isStartEnabled, setIsStartEnabled] = useState(false);

    // Timer state for countdown to next game start
    const [initialTimerMs, setInitialTimerMs] = useState(0);
    const initialResumeTimerMs = 1 * 60 * 1000;
    const hasInitialized = useHref(false);

    // Reset timerComplete when initialTimerMs changes (e.g., after nextGame update)
    useEffect(() => {
        setTimerComplete(false);
    }, [initialTimerMs]);

    useEffect(() => {
        logger.log('Rapchick RapHousieWaiting');
        if (nextGame === null) {
            //hasInitialized.current = true;
            mqttService.disconnect();
            findGame();
        }
        return () => {

        };
    }, [navigate]);

    const findGame = async () => {
        try {
            const userAuthTokenDetails = await authService.getAuthTokensFull();
            //logger.log('accessToken:', userAuthTokenDetails);

            //const userProfileData = await getUserProfile();
            //logger.log('User profile data:', userProfileData?.data?.data?.userId);

            //const IotPolicyResult = await attachIdentityIdToPolicyViaAPI(userAuthTokenDetails?.identityId);
            //logger.log('User IoT policy attachment result:', IotPolicyResult);

            const response = await tambolaGameList();

            if (response?.data?.error) {
                logger.log('Error : ', response?.error?.message);
                return;
            }

            const { gameList, nextGame } = response?.data?.data;

            logger.log('📘 gameList : ', gameList);
            logger.log('📘 nextGame : ', nextGame);

            //const liveGame = gameList.find(game => game?.status?.toLowerCase() === 'lobby');
            const liveGame = null;
            const activeGames = gameList.filter(game => game?.status?.toLowerCase() === 'active');
            const currentGame = liveGame ? liveGame : nextGame;
            setGamesList(gameList);
            setNextGame(currentGame);

            logger.log('📘 liveGame : ', liveGame);
            logger.log('📘 nextGame : ', nextGame);
            logger.log('📘 currentGame : ', currentGame);

            // Calculate ms until startTime and redirect if game started
            if (currentGame?.startTime) {
                const now = new Date();
                const [time, period] = currentGame.startTime.split(' ');
                let [hours, minutes] = time.split(':').map(Number);
                //logger.log("Next Game Start Time: ", hours, minutes, period);
                if (period === 'PM' && hours < 12) hours += 12;
                if (period === 'AM' && hours === 12) hours = 0;
                const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
                // If start time already passed today, assume it's for tomorrow
                let msUntilStart = startDate - now;
                //logger.log("msUntilStart : ", msUntilStart)
                if (startDate < now) {
                    msUntilStart = 0;
                }
                setInitialTimerMs(msUntilStart > 0 ? msUntilStart : 0);
                // If game already started, redirect to live-game
                if (msUntilStart <= 0) {
                    //navigate('/RapHousieGameLive', { replace: true, state: { nextGame } });
                    navigate(ROUTE_ENUM.RAP_HOUSIE_GAME_LIVE.routePath, { replace: true, state: { nextGame: currentGame } });
                }
                //navigate('/RapHousieGameLive', { replace: true, state: { nextGame } });
            }
        } catch (error) {
            console.error('❌ Failed to findGame:', error);
        }
    }

    const handleStartGame = () => {
        logger.log('Start game clicked');
        // Open the resume game modal
        //setIsModalOpen(true);
        //navigate('/RapHousieGameLive', { replace: true, state: { nextGame } });
        navigate(ROUTE_ENUM.RAP_HOUSIE_GAME_LIVE.routePath, { replace: true, state: { nextGame } })
    };

    const handleResumeGame = () => {
        logger.log('Resume game clicked');
        // Close modal and navigate to game result page
        setIsModalOpen(false);
        navigate(ROUTE_ENUM.RAP_HOUSIE_LEADERBOARD.routePath, { replace: true });
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    const handleTimerComplete = () => {
        setTimerComplete(true);
        //handleStartGame();
    };

    // Helper to get nextGame start time in ms
    function getNextGameStartMs() {
        if (!nextGame?.startTime) return null;
        const now = new Date();
        const [time, period] = nextGame.startTime.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        if (period === 'PM' && hours < 12) hours += 12;
        if (period === 'AM' && hours === 12) hours = 0;
        const startDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes, 0, 0);
        return startDate.getTime();
    }

    // Timer to enable button when start time matches current time
    useEffect(() => {
        if (!nextGame?.startTime) {
            setIsStartEnabled(false);
            return;
        }
        const checkEnable = () => {
            const nowMs = Date.now();
            const startMs = getNextGameStartMs();
            if (startMs !== null && nowMs >= startMs) {
                //setIsStartEnabled(true);
                handleStartGame();
            } else {
                setIsStartEnabled(false);
            }
        };
        checkEnable();
        const interval = setInterval(checkEnable, 1000);
        return () => clearInterval(interval);
    }, [nextGame?.startTime]);

    return (
        <ParentContainor
            route={ROUTE_ENUM.SELECT_RAP_HOUSIE_GAME}
            parentContainorStyle={{ justifyContent: 'center' }}
            isShowHeader={true}
            isBreadcrumbVisible={true}
            breadCrumbShowBack={true}
            breadCrumbOnBack={() => navigate(ROUTE_ENUM.SELECT_RAP_HOUSIE_GAME.routePath)}
            items={[]}
        >
            <div style={{
                display: 'flex',
                flex: 1,
                height: '80%',
                width: '100%',
                flexDirection: 'column',
                gap: 30,
                padding: 10,
                justifyContent: 'center',
                alignItems: 'center',
            }}>

                <Card
                    elevation={5}
                    radius={20}
                    animation={true}
                    style={{
                        display: 'flex',
                        padding: '20px',
                        height: '100%',
                        width: '75%',
                        justifyContent: 'start',
                        alignItems: 'center',
                        flexDirection: 'column',
                    }}>

                    <div style={{
                        display: 'flex',
                        flex: 0,
                        width: '100%',
                        height: 'auto',
                        justifyContent: 'center',
                        alignItems: 'center',
                        textAlign: 'center',
                        flexDirection: 'column',
                    }}>
                        <GradientText
                            text={`RapHousie @ ${nextGame?.startTime || ''}`}
                            fontWeight={700}
                            fontSize={62}
                            style={{
                                marginTop: 20
                            }}
                        />

                        <GradientText
                            text={TEXT_LABELS.RAP_HOUSIE_WE_WORK_COMPANY_NAME}
                            fontWeight={500}
                            fontSize={32}
                            textColor={'#FFFFFFE5'}
                            style={{
                                marginTop: 10
                            }}
                        />

                    </div>

                    <div style={{
                        flex: 1,
                        width: 'auto',
                        height: '100%',
                        justifyContent: 'center',
                        alignItems: 'center',
                        alignContent: 'center',
                        textAlign: 'center',
                    }}>
                        <QRCode
                            value="RAP_HOUSIE_EVENT_QR"
                            width="15vw"
                            height="30vh"
                            backgroundColor="#F3F3F3"
                            borderColor="#ffffff"
                            borderRadius="40px"
                        />

                        {/* <GradientText
                            text={`${nextGameCountDown} mins ${TEXT_LABELS.RAP_HOUSIE_TIME_REMAINING}`}
                            fontWeight={700}
                            fontSize={22}
                            fontFamily={FONTS.MONTSERRAT_BOLD}
                            textColor={'#FFFFFFE5'}
                            style={{
                                marginTop: 40,
                                textAlign: 'center',
                            }}
                        /> */}
                    </div>

                    <Button
                        text={TEXT_LABELS.RAP_HOUSIE_START_GAME_BUTTON_LABEL}
                        onClick={handleStartGame}
                        backgroundColor={COLORS_CONSTANTS.ACTION_BUTTON_BACKGROUND_1}
                        color={COLORS_CONSTANTS.ACTION_BUTTON_TEXT_1}
                        height={'60px'}
                        fontSize={28}
                        fontWeight={700}
                        borderRadius={'10px'}
                        disabled={!isStartEnabled}
                        style={{ marginTop: 40, marginBottom: 40, paddingLeft: 100, paddingRight: 100 }}
                    />

                </Card>

            </div>
        </ParentContainor>
    );
};

export default RapHousieWaiting;